import { Component, OnInit, HostListener } from "@angular/core";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
    isShow: boolean = false;

    constructor() { }

    ngOnInit() { }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        if (window.scrollY > 600) {
            this.isShow = true;
        } else {
            this.isShow = false;
        }
    }

    goToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
